import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, SparklesIcon } from 'lucide-react';
export function CTASection() {
  return <section className="py-24 lg:py-32 bg-slate-900 relative overflow-hidden" data-id="element-28">
      {/* Animated Background */}
      <div className="absolute inset-0" data-id="element-29">
        <motion.div animate={{
        backgroundPosition: ['0% 0%', '100% 100%']
      }} transition={{
        duration: 20,
        repeat: Infinity,
        repeatType: 'reverse',
        ease: 'linear'
      }} className="absolute inset-0 opacity-10" style={{
        backgroundImage: `linear-gradient(to right, rgba(251, 146, 60, 0.3) 1px, transparent 1px),
                             linear-gradient(to bottom, rgba(251, 146, 60, 0.3) 1px, transparent 1px)`,
        backgroundSize: '64px 64px'
      }} data-id="element-30" />
      </div>

      {/* Glowing Orbs */}
      <motion.div animate={{
      scale: [1, 1.2, 1],
      opacity: [0.2, 0.4, 0.2]
    }} transition={{
      duration: 8,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute top-1/4 right-1/4 w-96 h-96 bg-orange-500/30 rounded-full blur-3xl" data-id="element-31" />
      <motion.div animate={{
      scale: [1, 1.3, 1],
      opacity: [0.2, 0.3, 0.2]
    }} transition={{
      duration: 10,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-pink-500/20 rounded-full blur-3xl" data-id="element-32" />

      <div className="relative z-10 mx-auto max-w-4xl px-6 lg:px-8 text-center" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-34">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-4 py-2 bg-orange-500/10 backdrop-blur-sm rounded-full border border-orange-500/20 mb-8" data-id="element-35">
            <SparklesIcon className="w-4 h-4 text-orange-400" data-id="element-36" />
            <span className="text-sm font-medium text-orange-300" data-id="element-37">
              Join 10,000+ nonprofits
            </span>
          </motion.div>

          <h2 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-38">
            Ready to start accepting donations?
          </h2>
          <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-39">
            Join thousands of nonprofits processing payments instantly. No setup
            fees, no long-term contracts, no BS.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-40">
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="group relative px-8 py-4 bg-gradient-to-r from-orange-500 to-pink-500 text-white rounded-full font-semibold overflow-hidden shadow-xl hover:shadow-2xl hover:shadow-orange-500/30 transition-all" data-id="element-41">
              <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-42">
                Start Free Trial
                <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-43" />
              </span>
            </motion.button>
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white rounded-full font-semibold hover:bg-white/20 transition-all border border-white/20" data-id="element-44">
              Schedule a Demo
            </motion.button>
          </div>
          <p className="text-slate-400 text-sm mt-6" data-id="element-45">
            No credit card required • Live in 30 minutes • Cancel anytime
          </p>
        </motion.div>
      </div>
    </section>;
}